/**
 * @generated SignedSource<<f179c23d5d7b69ed197524831d8c90ce>>
 * @relayHash 93eb6d138beec185d67623d9c48fbcc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5094f205b5ae968581f2240e31ccd2fb61ff3b3921fa4a96d72f6205db43b32

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';
import withDisplayMessage_provider from '@atlassian/jira-relay-provider/src/mbw-191-display-flags-in-case-of-no-columns.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f5094f205b5ae968581f2240e31ccd2fb61ff3b3921fa4a96d72f6205db43b32",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": withDisplayMessage_provider
    }
  }
};

export default node;
